import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox'; 
const styles = theme => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
});

class MemberListCheck extends React.Component 
{ 
 

  render() {
    const { classes } = this.props; 
    return (
      <List className={classes.root}>
        <h1>Team Members</h1>
        {this.props.members.map(member => (
          <ListItem key={member.member} role={undefined} dense button onClick={this.props.handleToggle(member)}>
            <Checkbox
              checked={member.checked === true}
              tabIndex={-1}
              disableRipple
              disabled={this.props.reviewActive}
            />
            <ListItemText primary={`${member.first_name} ${member.last_name} (${member.position})`} />
          </ListItem>
        ))}
      </List>
    );
  }
}

MemberListCheck.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MemberListCheck);


// WEBPACK FOOTER //
// ./src/features/common/MemberListCheck.js